import script from "./AccountButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountButton.vue?vue&type=script&setup=true&lang=ts"

import "./AccountButton.vue?vue&type=style&index=0&id=ad1a29e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad1a29e6"]])

export default __exports__